import Page from "../../components/Page.jsx";
import useTagsList from "./hooks/useTagsList.js";

const TagsList = () => {
  const page = useTagsList();
  return <Page {...page} />;
};

export default TagsList;
